<template>
    <div class="Card">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Card',
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.Card {
    width: 100%;
    padding: 40px;
    box-shadow: $shadow-soft;
    background-color: $bg-color-1;
    border-radius: $border-radius;
}
</style>
